import type { ComboboxItem } from "@mantine/core";
import { Grid, Text } from "@mantine/core";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Select } from "src/components/shared/MantineCombobox";
import { useGetApi } from "src/hooks";
import { UserSettingsContainer } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { Flex, StyledTable, StyledTh, StyledTr } from "src/styled";
import { getYachtId } from "src/utils";

import { specMapper } from "../NMEA.utils";
import NMEAMappingItem from "./NMEAMappingItem";

interface Props {
  logbooks: ComboboxItem[];
  watch: (name: string) => any;
  disabled: boolean | undefined;
}

const NMEAMapping = ({ logbooks, watch, disabled }: Props) => {
  const { setValue } = useFormContext();
  const [selectedLogbook, setSelectedLogbook] = useState<string | null>(null);

  const { data, refetch } = useGetApi({
    request: "get-nmea-logbook-spec",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
    mapper: specMapper,
  });

  const handleLogbookChange = async (value: string | null) => {
    setSelectedLogbook(value);
    const data = await refetch({
      params: {
        lbid: value,
      },
    });
    if (!data) return;
    setValue(`list.${value}`, data.list ?? []);
  };
  return (
    <Grid.Col span={1}>
      <UserSettingsContainer
        style={{
          flexDirection: "column",
          padding: 20,
          ...(disabled && { opacity: 0.5, pointerEvents: "none" }),
        }}>
        <Text mb={15}>Mapping</Text>
        <Flex gap={10} direction="column">
          <Select
            value={selectedLogbook}
            label="Logbook"
            onChange={handleLogbookChange}
            data={logbooks}
            maw={300}
          />
          {!data ? (
            <Text ta="center">
              {disabled
                ? "You must first save your credentials to edit mapping"
                : "You must first select logbook to edit mapping"}
            </Text>
          ) : (
            <div style={{ overflowY: "scroll", height: 600 }}>
              <StyledTable>
                <StyledTr>
                  <StyledTh>Column Name</StyledTh>
                  <StyledTh>Mapped ID</StyledTh>
                </StyledTr>
                {data.list.map((item, index) => (
                  <NMEAMappingItem
                    key={`mapping-${index}`}
                    index={index}
                    watch={watch}
                    lbid={selectedLogbook}
                    availableMappings={data.availableMappings}
                    {...item}
                  />
                ))}
              </StyledTable>
            </div>
          )}
        </Flex>
      </UserSettingsContainer>
    </Grid.Col>
  );
};
export default NMEAMapping;
